
<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="state"
    :disabled="disabled || loading"
    :placeholder="placeholder"
    v-bind="$attrs"
  />
</template>

<script>
// ajuste o caminho conforme sua pasta de componentes
import CecSelectSearch from './CecSelectSearch.vue';
import axios from 'axios'; // ou use this.$http / this.$axios se já tiver

export default {
  name: 'HistoricoDropdown',
  components: { CecSelectSearch },
  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Pesquise pelo nome ou codigo...'
    },
    tipo: {
      type: String,
      default: 'CREDITO' // Tipo: CREDITO | DEBITO | COMPENSACAO | ACOMPENSAR
    },
  },

  data: function () {
    return {
      internalValue: this.value,
      options: [],
      loading: false
    };
  },

  watch: {
    // sincroniza v-model externo -> interno
    value: function (newVal) {
      this.internalValue = newVal;
    },
    // propaga interno -> v-model do pai
    internalValue: function (newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal); // opcional, ajuda se você ouve @change
    },
    // re-busca se o tipo mudar
    tipo: function () {
      this.fetchRegistros();
    }
  },

  created: function () {
    this.fetchRegistros();
  },

  methods: {
    fetchRegistros: function () {
      var self = this;
      this.loading = true;

      axios
        .get('/api/protected/historico/getAtivos/' + this.tipo)
        .then(function (response) {
          var data = response.data || [];

          // ajuste aqui se o seu backend devolver em outra estrutura, ex: data.rows
          self.options = data.map(function (item) {
            return {
              value: item.ID,
              text: item.CODIGONOME
            };
          });
        })
        .catch(function (error) {
          // opcional: você pode disparar um toast aqui
          // self.$bvToast.toast('Erro ao buscar vendedores', { variant: 'danger' });
          console.error('Erro ao buscar historicos', error);
        })
        .finally(function () {
          self.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/HistoricoCaixaDropdown.vue